module.exports = __webpack_public_path__ + "img/icon-camera.15f973f3.png";